/**
 * AÏNN London — Product Customisations & Add-Ons
 * ================================================
 *
 * STABLE BUNDLED VERSION (post-1-June-2026 incident).
 *
 * Behaviour:
 * - Customer selects customisations (Top Style, Bottoms Style, Custom Colour,
 *   Dupatta Upgrade) AND/OR ticks Complete the Look add-ons (hijab, potli,
 *   pocket square), THEN clicks the main Add to Cart button.
 * - Everything goes into the cart in one bundled fetch to /cart/add.js.
 * - If nothing extra is selected, the form submits natively so Heritage's
 *   product-form-component handles it (and respects the theme's Cart Type
 *   setting — drawer or page).
 *
 * Known open issue (parked for later):
 * - When customisations or add-ons ARE selected, our submit interceptor
 *   does the bundled add but Heritage's component may not always pick up
 *   that interception cleanly because it listens to the button's click,
 *   not the form's submit event. This can result in only the main outfit
 *   being added in some cases. To be fixed by either:
 *   (a) intercepting the button click in capture phase, or
 *   (b) injecting hidden form fields for customisation properties and a
 *       separate cart-add fetch for add-ons after Heritage's add completes.
 */

(function() {
  'use strict';

  function waitForElements() {
    if (document.getElementById('ainn-customise-wrap')) {
      init();
    } else {
      setTimeout(waitForElements, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForElements);
  } else {
    waitForElements();
  }

  function init() {
    const wrap = document.getElementById('ainn-customise-wrap');
    if (!wrap) return;

    setupColourField();
    setupDupattaNote();
    setupStyleChangeListeners();
    interceptAddToCart();
  }

  function setupColourField() {
    document.addEventListener('change', function(e) {
      if (e.target.id !== 'ainn-custom-colour') return;
      var field = document.getElementById('ainn-colour-field');
      if (!field) return;
      field.style.display = e.target.value === 'custom' ? 'block' : 'none';
      updatePriceSummary();
      recalcBodyHeight();
    });
  }

  function setupDupattaNote() {
    document.addEventListener('change', function(e) {
      if (e.target.id !== 'ainn-dupatta-style') return;
      var note = document.getElementById('ainn-dupatta-note');
      if (!note) return;
      note.style.display = e.target.value !== 'standard' ? 'block' : 'none';
      updatePriceSummary();
      recalcBodyHeight();
    });
  }

  function setupStyleChangeListeners() {
    document.addEventListener('change', function(e) {
      if (e.target.id === 'ainn-top-style' || e.target.id === 'ainn-bottoms-style') {
        updatePriceSummary();
        recalcBodyHeight();
      }
    });
  }

  function updatePriceSummary() {
    const summary = document.getElementById('ainn-custom-summary');
    const totalEl = document.getElementById('ainn-custom-total');
    if (!summary || !totalEl) return;
    const total = calculateCustomisationTotal();
    if (total > 0) {
      summary.style.display = 'block';
      totalEl.textContent = '+£' + (total / 100).toFixed(2);
    } else {
      summary.style.display = 'none';
    }
  }

  function calculateCustomisationTotal() {
    let total = 0;
    const colourSelect = document.getElementById('ainn-custom-colour');
    if (colourSelect && colourSelect.value === 'custom') {
      total += parseInt(colourSelect.dataset.price) || 0;
    }
    const topSelect = document.getElementById('ainn-top-style');
    const bottomsSelect = document.getElementById('ainn-bottoms-style');
    if (topSelect && topSelect.value !== 'standard') {
      total += parseInt(topSelect.dataset.price) || 0;
    }
    if (bottomsSelect && bottomsSelect.value !== 'standard') {
      total += parseInt(bottomsSelect.dataset.price) || 0;
    }
    const dupattaSelect = document.getElementById('ainn-dupatta-style');
    if (dupattaSelect && dupattaSelect.value !== 'standard') {
      total += parseInt(dupattaSelect.dataset.price) || 0;
    }
    return total;
  }

  function recalcBodyHeight() {
    const body = document.getElementById('ainn-customise-body');
    if (body && body.style.maxHeight && body.style.maxHeight !== '0px') {
      setTimeout(function() {
        body.style.maxHeight = body.scrollHeight + 'px';
      }, 50);
    }
  }

  function interceptAddToCart() {
    const productForm = document.querySelector('form[action="/cart/add"], form[action*="/cart/add"]');
    if (!productForm) return;

    productForm.addEventListener('submit', function(e) {
      const topSelect = document.getElementById('ainn-top-style');
      const bottomsSelect = document.getElementById('ainn-bottoms-style');
      const colourSelect = document.getElementById('ainn-custom-colour');
      const dupattaSelect = document.getElementById('ainn-dupatta-style');
      const colourKameez = document.getElementById('ainn-colour-kameez');
      const colourTrouser = document.getElementById('ainn-colour-trouser');
      const colourDupatta = document.getElementById('ainn-colour-dupatta');

      const hasTopCustom = topSelect && topSelect.value !== 'standard';
      const hasBottomsCustom = bottomsSelect && bottomsSelect.value !== 'standard';
      const hasColourCustom = colourSelect && colourSelect.value === 'custom';
      const hasDupattaCustom = dupattaSelect && dupattaSelect.value !== 'standard';
      const checkedAddons = document.querySelectorAll('.ainn-addon-checkbox:checked');
      const hasAddons = checkedAddons.length > 0;

      const needsBundling = hasTopCustom || hasBottomsCustom || hasColourCustom || hasDupattaCustom || hasAddons;

      if (!needsBundling) {
        // Let Heritage handle natively
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      const items = [];
      const mainVariantInput = productForm.querySelector('input[name="id"], select[name="id"]');
      if (!mainVariantInput) {
        productForm.submit();
        return;
      }
      const mainVariantId = mainVariantInput.value;
      const qtyInput = productForm.querySelector('input[name="quantity"]');
      const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      const mainProperties = {};
      if (hasColourCustom) {
        const kameezVal = colourKameez ? colourKameez.value.trim() : '';
        const trouserVal = colourTrouser ? colourTrouser.value.trim() : '';
        const dupattaColVal = colourDupatta ? colourDupatta.value.trim() : '';
        if (kameezVal) mainProperties['Kameez Colour'] = kameezVal;
        if (trouserVal) mainProperties['Trouser Colour'] = trouserVal;
        if (dupattaColVal) mainProperties['Dupatta Colour'] = dupattaColVal;
      }
      if (hasTopCustom) mainProperties['Top Style'] = topSelect.value;
      if (hasBottomsCustom) mainProperties['Bottoms Style'] = bottomsSelect.value;
      if (hasDupattaCustom) mainProperties['Dupatta'] = 'Heavy Embroidery on all 4 sides';

      items.push({
        id: parseInt(mainVariantId),
        quantity: qty,
        properties: Object.keys(mainProperties).length > 0 ? mainProperties : undefined
      });

      const productTitleEl = document.querySelector('.product__title, h1.product-single__title, .product-title, h1');
      const productTitle = productTitleEl ? productTitleEl.textContent.trim() : 'Main product';

      if (hasTopCustom && topSelect.dataset.variantId) {
        items.push({
          id: parseInt(topSelect.dataset.variantId),
          quantity: qty,
          properties: { 'For': productTitle, 'Top Style': topSelect.value }
        });
      }
      if (hasBottomsCustom && bottomsSelect.dataset.variantId) {
        items.push({
          id: parseInt(bottomsSelect.dataset.variantId),
          quantity: qty,
          properties: { 'For': productTitle, 'Bottoms Style': bottomsSelect.value }
        });
      }
      if (hasColourCustom && colourSelect.dataset.variantId) {
        const kameezCol = colourKameez ? colourKameez.value.trim() : '';
        const trouserCol = colourTrouser ? colourTrouser.value.trim() : '';
        const dupattaCol = colourDupatta ? colourDupatta.value.trim() : '';
        items.push({
          id: parseInt(colourSelect.dataset.variantId),
          quantity: qty,
          properties: {
            'For': productTitle,
            'Kameez Colour': kameezCol || 'To be confirmed',
            'Trouser Colour': trouserCol || 'To be confirmed',
            'Dupatta Colour': dupattaCol || 'To be confirmed'
          }
        });
      }
      if (hasDupattaCustom && dupattaSelect.dataset.variantId) {
        items.push({
          id: parseInt(dupattaSelect.dataset.variantId),
          quantity: qty,
          properties: { 'For': productTitle }
        });
      }

      checkedAddons.forEach(function(checkbox) {
        const id = parseInt(checkbox.value);
        if (!id) return;
        items.push({
          id: id,
          quantity: 1,
          properties: { 'For': productTitle }
        });
      });

      addItemsToCart(items);
    });
  }

  function addItemsToCart(items) {
    if (!items || items.length === 0) return;

    const cleanItems = items.map(function(item) {
      const clean = { id: item.id, quantity: item.quantity };
      if (item.properties && Object.keys(item.properties).length > 0) {
        clean.properties = item.properties;
      }
      return clean;
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: cleanItems })
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(err) {
          throw new Error(err.description || err.message || 'Could not add to cart');
        });
      }
      return response.json();
    })
    .then(function(data) {
      const itemCount = Array.isArray(data) ? data.length : (data && data.items ? data.items.length : cleanItems.length);
      const message = itemCount > 1
        ? 'Added to your bag (' + itemCount + ' items)'
        : 'Added to your bag';
      showAddonToast(message);
      resetAddonCheckboxes();
    })
    .catch(function(error) {
      console.error('AINN Add to Cart Error:', error);
      showAddonToast('Could not add to cart. Please try again.', true);
    });
  }

  function resetAddonCheckboxes() {
    const checked = document.querySelectorAll('.ainn-addon-checkbox:checked');
    checked.forEach(function(cb) {
      cb.checked = false;
      const label = cb.closest('[data-cyl-label]');
      if (label) label.classList.remove('is-added');
      const txt = label ? label.querySelector('.ainn-cyl-add-text') : null;
      if (txt) txt.textContent = '+ Add';
    });
    const counter = document.getElementById('ainn-cyl-count');
    if (counter) counter.textContent = '';
  }

  function showAddonToast(message, isError) {
    const existing = document.getElementById('ainn-addon-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.id = 'ainn-addon-toast';
    toast.textContent = message;
    toast.style.cssText = [
      'position: fixed',
      'bottom: 24px',
      'right: 24px',
      'background: ' + (isError ? '#8b1a1a' : '#1a1a1a'),
      'color: #fff',
      'padding: 14px 22px',
      'font-family: inherit',
      'font-size: 13px',
      'letter-spacing: 0.5px',
      'box-shadow: 0 8px 24px rgba(0,0,0,0.25)',
      'z-index: 99999',
      'opacity: 0',
      'transform: translateY(10px)',
      'transition: opacity 0.25s ease, transform 0.25s ease',
      'max-width: 280px',
      'border-left: 3px solid ' + (isError ? '#ff6b6b' : '#c9a959')
    ].join(';');

    document.body.appendChild(toast);
    void toast.offsetWidth;
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';

    setTimeout(function() {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(10px)';
      setTimeout(function() {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 300);
    }, 2500);
  }

})();